/**
 * Contacts Service Barrel Export
 *
 * Central export point for all contact-related functionality.
 */

// Types
export * from './types';

// Reads + mutations (LF-3215 / LF-3216 — directApiClient).
// Server-side reads flow through `lib/data/matter-reads.ts`.
export {
  // Reads (LF-3215)
  fetchMatterContacts,
  fetchGlobalContact,
  fetchBankVerificationDetails,
  // Mutations
  createContactAction,
  updateContactAction,
  deleteContactAction,
  createGlobalContactAction,
  updateGlobalContactAction,
  deleteGlobalContactAction,
  requestBankVerificationAction,
  resendVerificationLinkAction,
  approveBankVerificationAction,
  confirmContactIdentityAction
} from './client';

// Utilities
export {
  // Contact type detection
  isOrganisationContact,
  getContactType,
  isContactDeceased,

  // Formatting
  getContactDisplayName,

  // Search and filter
  filterContactsByType,

  // Data transformation
  sortContactsByImportance,

  // Cache management
  getContactsCacheKey,
  getContactCacheKey,

  // Export functions
  exportContactsToCSV
} from './utils';

// Hooks (Client-side)
export {
  useMatterContacts,
  useGlobalContacts,
  useInfiniteGlobalContacts,
  useContact,
  useCreateContact,
  useUpdateContact,
  useDeleteContact,
  useConfirmContactIdentity,
  useMarkReadyToPay,
  useMarkNotReadyToPay,
  useMatterContactsService
} from './hooks';
